import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import {
  toggleCustomerRepsView,
  createCustomerRep,
  editCustomerRep,
  deleteCustomerRep,
  CreateCustomerRep,
  EditCustomerRep,
  DeleteCustomerRep
} from '../../../../actions';
import { IAppState } from '../../../../reducers/index';
import ViewRepsModal from './ViewRepsModal';

const mapStateToProps = ({ customers }: IAppState) => ({
  customerId: customers.repsView.customerId || 0,
  customer: customers.customers[customers.repsView.customerId || 0] || {},
  loading: customers.repsView.loading,
  redirectReady: customers.repsView.redirectReady,
});

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    toggleCustomerRepsView: (customerId?: number) =>
      dispatch(toggleCustomerRepsView(customerId)),
    createCustomerRep: (properties: CreateCustomerRep) =>
      dispatch(createCustomerRep.request(properties)),
    editCustomerRep: (properties: EditCustomerRep) =>
      dispatch(editCustomerRep.request(properties)),
    deleteCustomerRep: (properties: DeleteCustomerRep) =>
      dispatch(deleteCustomerRep.request(properties)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewRepsModal);